import { NgModule } from '@angular/core';
import { TextInputComponent } from './components/text-input/text-input.component';
import { ReactiveFormsModule } from '@angular/forms';
import { OtpInputComponent } from './components/otp-input/otp-input.component';
import { CommonModule } from '@angular/common';
import { SelectInputComponent } from './components/select-input/select-input.component';
import { ErrorComponent } from './components/error/error.component';
import { NomidioFormsService } from './nomidio-forms.service';



@NgModule({
  declarations: [
    TextInputComponent,
    OtpInputComponent,
    SelectInputComponent,
    ErrorComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
  ],
  exports: [
    TextInputComponent,
    OtpInputComponent,
    SelectInputComponent,
    ErrorComponent,
  ],
  providers: [
    NomidioFormsService,
  ]
})
export class NomidioFormsModule { }
